<template>
<div>
    <h1 class="mb-4 text-gray-500">All Downloaders</h1>
    <div class="flex gap-5 flex-wrap" >
        <router-link v-for="website in websites" :key="website.name" :to="website.link">
            <el-card shadow="never" :body-style="{ padding: '20px', width: '400px' }">
                <div class="flex align-center gap-5 justify-between">
                    <h1 class="mb-0"> {{ website.name }} </h1> 
                    <el-tag size="small" v-if="!website.live" type="primary" effect="dark">Coming soon</el-tag>
                    <el-tag size="small" v-if="website.beta" type="warning" effect="dark">Beta</el-tag>
                </div>
                <div>
                    <!-- {{website.description}} -->
                </div>
            </el-card>
        </router-link>
    </div>
</div>
</template>
<script>
export default {
    created() {
        useHead({
            title: 'List of websites supported to download media files',
            head: {
                meta: [
                    {
                        hid: 'description',
                        name: 'description',
                        content: 'List of all websites supported by anyloader to download videos and photos in bulk using chrome extension',
                    }
                ]
            }
        })
    },
    data () {
        return {
            websites: [
                {
                    name: 'Onlyfans downloader',
                    description: 'Onlyfans downloader is a software designed to allow users to download content from onlyfans.com, from posts, profiles and chats for offline viewing.',
                    thumbnail: '',
                    link: '/',
                    live: true,
                },
                {
                    name: 'Fansly downloader',
                    description: 'Fansly downloader is a software designed to allow users to download content from fansly.com, from posts, profiles and chats for offline viewing.',
                    thumbnail: '',
                    link: '/fansly-downloader',
                    live: true,
                },
                {
                    name: 'Redgifs Downloader',
                    description: 'Redgifs downloader is a software designed to allow users to download content from redgifs.com, from posts, profiles and chats for offline viewing.',
                    thumbnail: '',
                    link: '/redgifs-downloader',
                    live: true,
                },
                {
                    "name": "BiliBili Downloader",
                    "description": "BiliBili Downloader is a tool that enables you to download videos from BiliBili for offline viewing. This software allows you to save your favorite BiliBili content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/bilibili-downloader",
                    "live": true,
                },
                {
                    "name": "Eporner Downloader",
                    "description": "Eporner Downloader is a tool that lets you download videos from Eporner.com for offline viewing. With this software, you can save your favorite Eporner content for later, ensuring you can watch it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/eporner-downloader",
                    "live": true,
                },
                {
                    "name": "aShemaleTube Downloader",
                    "description": "aShemaleTube Downloader is a tool that lets you download videos from aShemaleTube.com for offline viewing. With this software, you can save your favorite aShemaleTube content for later, ensuring you can watch it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/ashemaletube-downloader",
                    "live": true,
                },
                {
                    "name": "BoyfriendTV Downloader",
                    "description": "BoyfriendTV Downloader is a tool that lets you download videos from BoyfriendTV.com for offline viewing. With this software, you can save your favorite BoyfriendTV content for later, ensuring you can watch it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/boyfriendtv-downloader",
                    "live": true
                },
                {
                    "name": "Tnaflix Downloader",
                    "description": "Tnaflix Downloader is a tool that lets you download videos from Tnaflix.com for offline viewing. With this software, you can save your favorite Tnaflix content for later, ensuring you can watch it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/tnaflix-downloader",
                    "live": true
                },
                {
                    "name": "Shesfreaky Downloader",
                    "description": "Shesfreaky Downloader is a tool that allows you to download videos from Shesfreaky.com for offline viewing. This software enables you to save your favorite Shesfreaky content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/shesfreaky-downloader",
                    "live": true
                },
                {
                    "name": "xHamster Downloader",
                    "description": "xHamster Downloader is a tool that allows you to download videos from xHamster.com for offline viewing. This software enables you to save your favorite xHamster content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/xhamster-downloader",
                    "live": true
                },
                {
                    "name": "SpankBang Downloader",
                    "description": "SpankBang Downloader is a tool that lets you download videos from SpankBang.com for offline viewing. With this software, you can save your favorite SpankBang content for later, ensuring you can watch it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/spankbang-downloader",
                    "live": true
                },
                {
                    name: 'Porntrex Downloader',
                    description: 'Porntrex downloader is a software designed to allow users to download content from porntrex.com, from posts, profiles and chats for offline viewing.',
                    thumbnail: '',
                    link: '/porntrex-downloader',
                },
                {
                    name: 'Deviantart Downloader',
                    description: 'Deviantart downloader is a software designed to allow users to download content from deviantart.com, from posts, profiles and chats for offline viewing.',
                    thumbnail: '',
                    link: '/deviantart-downloader',
                },
                {
                    name: 'Pornhub Downloader',
                    description: 'Pornhub downloader is a software designed to allow users to download content from pornhub.com, from posts, profiles and chats for offline viewing.',
                    thumbnail: '',
                    link: '/pornhub-downloader',
                },
                {
                    "name": "YouTube Downloader",
                    "description": "YouTube Downloader is a tool that lets you download videos from YouTube for offline viewing. It's a simple and easy-to-use software that allows you to save your favorite YouTube content for later.",
                    "thumbnail": "",
                    "link": "/youtube-downloader"
                },
                
                {
                    "name": "Youku Downloader",
                    "description": "Youku Downloader is a tool that lets you download videos from Youku for offline viewing. With this software, you can save your favorite Youku content for later, ensuring you can watch it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/youku-downloader"
                },
                {
                    "name": "Vimeo Downloader",
                    "description": "Vimeo Downloader is a tool that allows you to download videos from Vimeo for offline viewing. This software enables you to save your favorite Vimeo content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/vimeo-downloader"
                },
                {
                    "name": "Facebook Downloader",
                    "description": "Facebook Downloader is a tool that lets you download videos from Facebook for offline viewing. With this software, you can save your favorite Facebook content for later, ensuring you can watch it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/facebook-downloader"
                },
                {
                    "name": "Instagram Downloader",
                    "description": "Instagram Downloader is a tool that allows you to download photos and videos from Instagram for offline viewing. This software enables you to save your favorite Instagram content for later, so you can view it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/instagram-downloader"
                },
                {
                    "name": "TikTok Downloader",
                    "description": "TikTok Downloader is a tool that lets you download videos from TikTok for offline viewing. With this software, you can save your favorite TikTok content for later, ensuring you can watch it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/tiktok-downloader"
                },
                {
                    "name": "Twitter Downloader",
                    "description": "Twitter Downloader is a tool that allows you to download photos and videos from Twitter for offline viewing. This software enables you to save your favorite Twitter content for later, so you can view it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/twitter-downloader"
                },
                {
                    "name": "Reddit Downloader",
                    "description": "Reddit Downloader is a tool that lets you download photos and videos from Reddit for offline viewing. With this software, you can save your favorite Reddit content for later, ensuring you can view it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/reddit-downloader"
                },
                {
                    "name": "Periscope Downloader",
                    "description": "Periscope Downloader is a tool that allows you to download videos from Periscope for offline viewing. This software enables you to save your favorite Periscope content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/periscope-downloader"
                },
                {
                    "name": "Twitch Downloader",
                    "description": "Twitch Downloader is a tool that lets you download videos from Twitch for offline viewing. With this software, you can save your favorite Twitch content for later, ensuring you can watch it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/twitch-downloader"
                },
                {
                    "name": "TED Downloader",
                    "description": "TED Downloader is a tool that allows you to download videos from TED for offline viewing. This software enables you to save your favorite TED talks for later, so you can watch them whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/ted-downloader"
                },
                {
                    "name": "Behance Downloader",
                    "description": "Behance Downloader is a tool that lets you download images from Behance for offline viewing. With this software, you can save your favorite Behance content for later, ensuring you can view it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/behance-downloader"
                },
                {
                    "name": "SoundCloud Downloader",
                    "description": "SoundCloud Downloader is a tool that lets you download music from SoundCloud for offline listening. With this software, you can save your favorite SoundCloud tracks for later, ensuring you can listen to them anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/soundcloud-downloader"
                },
                {
                    "name": "Bandcamp Downloader",
                    "description": "Bandcamp Downloader is a tool that allows you to download music from Bandcamp for offline listening. This software enables you to save your favorite Bandcamp tracks for later, so you can listen to them whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/bandcamp-downloader"
                },
                {
                    "name": "Audiomack Downloader",
                    "description": "Audiomack Downloader is a tool that lets you download music from Audiomack for offline listening. With this software, you can save your favorite Audiomack tracks for later, ensuring you can listen to them anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/audiomack-downloader"
                },
                {
                    "name": "Xvideos Downloader",
                    "description": "Xvideos Downloader is a tool that allows you to download videos from Xvideos.com for offline viewing. This software enables you to save your favorite Xvideos content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/xvideos-downloader"
                },
                {
                    "name": "XNXX Downloader",
                    "description": "XNXX Downloader is a tool that lets you download videos from XNXX.com for offline viewing. With this software, you can save your favorite XNXX content for later, ensuring you can watch it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/xnxx-downloader"
                },
               
                {
                    "name": "Motherless Downloader",
                    "description": "Motherless Downloader is a tool that allows you to download videos from Motherless.com for offline viewing. This software enables you to save your favorite Motherless content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/motherless-downloader"
                },
               
                {
                    "name": "HDsex Downloader",
                    "description": "HDsex Downloader is a tool that lets you download videos from HDsex.com for offline viewing. With this software, you can save your favorite HDsex content for later, ensuring you can watch it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/hdsex-downloader"
                },
                {
                    "name": "Beeg Downloader",
                    "description": "Beeg Downloader is a tool that allows you to download videos from Beeg.com for offline viewing. This software enables you to save your favorite Beeg content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/beeg-downloader"
                },
                {
                    "name": "The Fantazy Downloader",
                    "description": "The Fantazy Downloader is a tool that lets you download videos from TheFantazy.com for offline viewing. With this software, you can save your favorite TheFantazy content for later, ensuring you can watch it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/thefantazy-downloader"
                },
                {
                    "name": "TXXX Downloader",
                    "description": "TXXX Downloader is a tool that allows you to download videos from TXXX.com for offline viewing. This software enables you to save your favorite TXXX content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/txxx-downloader"
                },
                {
                    "name": "HClips Downloader",
                    "description": "HClips Downloader is a tool that lets you download videos from HClips.com for offline viewing. With this software, you can save your favorite HClips content for later, ensuring you can watch it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/hclips-downloader"
                },
               
                {
                    "name": "Kompoz Downloader",
                    "description": "Kompoz Downloader is a tool that allows you to download videos from Kompoz.com for offline viewing. This software enables you to save your favorite Kompoz content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/kompoz-downloader"
                },
                {
                    "name": "Perfectgirls Video Downloader",
                    "description": "Perfectgirls Video Downloader is a tool that lets you download videos from Perfectgirls.com for offline viewing. With this software, you can save your favorite Perfectgirls content for later, ensuring you can watch it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/perfectgirls-downloader"
                },
                {
                    "name": "Chaturbate Downloader",
                    "description": "Chaturbate Downloader is a tool that allows you to download videos from Chaturbate.com for offline viewing. This software enables you to save your favorite Chaturbate content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/chaturbate-downloader"
                },

                {
                    "name": "ShemaleZ Downloader",
                    "description": "ShemaleZ Downloader is a tool that allows you to download videos from ShemaleZ.com for offline viewing. This software enables you to save your favorite ShemaleZ content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/shemalez-downloader"
                },
                {
                    "name": "Hanime Downloader",
                    "description": "Hanime Downloader is a tool that allows you to download videos from Hanime.tv for offline viewing. This software enables you to save your favorite Hanime content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/hanime-downloader"
                },
                {
                    "name": "nHentai Downloader",
                    "description": "nHentai Downloader is a tool that lets you download videos from nHentai.net for offline viewing. With this software, you can save your favorite nHentai content for later, ensuring you can watch it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/nhentai-downloader"
                },
                {
                    "name": "PornPics Downloader",
                    "description": "PornPics Downloader is a tool that allows you to download images from PornPics.com for offline viewing. This software enables you to save your favorite PornPics content for later, so you can view it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/pornpics-downloader"
                },
                {
                    "name": "ImageFap Downloader",
                    "description": "ImageFap Downloader is a tool that lets you download images from ImageFap.com for offline viewing. With this software, you can save your favorite ImageFap content for later, ensuring you can view it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/imagefap-downloader"
                },
                {
                    "name": "ManyVids Downloader",
                    "description": "ManyVids Downloader is a tool that allows you to download videos from ManyVids for offline viewing. This software enables you to save your favorite ManyVids content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/manyvids-downloader"
                },
                {
                    "name": "Playvids Downloader",
                    "description": "Playvids Downloader is a tool that allows you to download videos from Playvids for offline viewing. This software enables you to save your favorite Playvids content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/playvids-downloader"
                },
                {
                    "name": "Thotflix Downloader",
                    "description": "Thotflix Downloader is a tool that allows you to download videos from Thotflix for offline viewing. This software enables you to save your favorite Thotflix content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/thotflix-downloader"
                },
                {
                    "name": "Peekvids Downloader",
                    "description": "Peekvids Downloader is a tool that allows you to download videos from Peekvids for offline viewing. This software enables you to save your favorite Peekvids content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/peekvids-downloader"
                },
                {
                    "name": "Pimpbunny Downloader",
                    "description": "Pimpbunny Downloader is a tool that allows you to download videos from Pimpbunny for offline viewing. This software enables you to save your favorite Pimpbunny content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/pimpbunny-downloader"
                },
                {
                    "name": "Bstation Downloader",
                    "description": "Bstation Downloader is a tool that allows you to download videos from Bstation for offline viewing. This software enables you to save your favorite Bstation content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/bstation-downloader"
                },
                {
                    "name": "Pornflip Downloader",
                    "description": "Pornflip Downloader is a tool that allows you to download videos from Pornflip for offline viewing. This software enables you to save your favorite Pornflip content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/pornflip-downloader"
                },
                {
                    "name": "Roshytv Downloader",
                    "description": "Roshytv Downloader is a tool that allows you to download videos from Roshytv for offline viewing. This software enables you to save your favorite Roshytv content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/roshytv-downloader"
                },
                {
                    "name": "Xtapes Downloader",
                    "description": "Xtapes Downloader is a tool that allows you to download videos from Xtapes for offline viewing. This software enables you to save your favorite Xtapes content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/xtapes-downloader"
                },
                {
                    "name": "Whoreshub Downloader",
                    "description": "Whoreshub Downloader is a tool that allows you to download videos from Whoreshub for offline viewing. This software enables you to save your favorite Whoreshub content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/whoreshub-downloader"
                },
                {
                    "name": "Onlyjerk Downloader",
                    "description": "Onlyjerk Downloader is a tool that allows you to download videos from Onlyjerk for offline viewing. This software enables you to save your favorite Onlyjerk content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/onlyjerk-downloader"
                },
                {
                    "name": "MissAV Downloader",
                    "description": "MissAV Downloader is a tool that allows you to download videos from MissAV for offline viewing. This software enables you to save your favorite MissAV content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/missav-downloader"
                },
                {
                    "name": "Javmost Downloader",
                    "description": "Javmost Downloader is a tool that allows you to download videos from Javmost for offline viewing. This software enables you to save your favorite Javmost content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/javmost-downloader"
                },
                {
                    "name": "Erome Downloader",
                    "description": "Erome Downloader is a tool that allows you to download videos from Erome for offline viewing. This software enables you to save your favorite Erome content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/erome-downloader"
                },
                {
                    "name": "KissJAV Downloader",
                    "description": "KissJAV Downloader is a tool that allows you to download videos from KissJAV for offline viewing. This software enables you to save your favorite KissJAV content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/kissjav-downloader"
                },
                {
                    "name": "HornyFap Downloader",
                    "description": "HornyFap Downloader is a tool that allows you to download videos from HornyFap for offline viewing. This software enables you to save your favorite HornyFap content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/hornyfap-downloader"
                },
                {
                    "name": "Pornhat Downloader",
                    "description": "Pornhat Downloader is a tool that allows you to download videos from Pornhat for offline viewing. This software enables you to save your favorite Pornhat content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/pornhat-downloader"
                },
                {
                    "name": "Pornobae Downloader",
                    "description": "Pornobae Downloader is a tool that allows you to download videos from Pornobae for offline viewing. This software enables you to save your favorite Pornobae content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/pornobae-downloader"
                },
                {
                    "name": "Perverzija Downloader",
                    "description": "Perverzija Downloader is a tool that allows you to download videos from Perverzija for offline viewing. This software enables you to save your favorite Perverzija content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/perverzija-downloader"
                },
                {
                    "name": "Baddiehub Downloader",
                    "description": "Baddiehub Downloader is a tool that allows you to download videos from Baddiehub for offline viewing. This software enables you to save your favorite Baddiehub content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/baddiehub-downloader"
                },
                {
                    "name": "Pornone Downloader",
                    "description": "Pornone Downloader is a tool that allows you to download videos from Pornone for offline viewing. This software enables you to save your favorite Pornone content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/pornone-downloader"
                },
                {
                    "name": "XfreeHD Downloader",
                    "description": "XfreeHD Downloader is a tool that allows you to download videos from XfreeHD for offline viewing. This software enables you to save your favorite XfreeHD content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/xfreehd-downloader"
                },
                {
                    "name": "Sxyprn Downloader",
                    "description": "Sxyprn Downloader is a tool that allows you to download videos from Sxyprn for offline viewing. This software enables you to save your favorite Sxyprn content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/sxyprn-downloader"
                },
                {
                    "name": "Noodlemagazine Downloader",
                    "description": "Noodlemagazine Downloader is a tool that allows you to download videos from Noodlemagazine for offline viewing. This software enables you to save your favorite Noodlemagazine content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/noodlemagazine-downloader"
                },
                {
                    "name": "Clips4sale Downloader",
                    "description": "Clips4sale Downloader is a tool that allows you to download videos from Clips4sale for offline viewing. This software enables you to save your favorite Clips4sale content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/clips4sale-downloader"
                },
                {
                    "name": "Camwhores Downloader",
                    "description": "Camwhores Downloader is a tool that allows you to download videos from Camwhores for offline viewing. This software enables you to save your favorite Camwhores content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/camwhores-downloader"
                },
                {
                    "name": "Jable Downloader",
                    "description": "Jable Downloader is a tool that allows you to download videos from Jable for offline viewing. This software enables you to save your favorite Jable content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/jable-downloader"
                },
                {
                    "name": "Kemono Downloader",
                    "description": "Kemono Downloader is a tool that allows you to download videos from Kemono for offline viewing. This software enables you to save your favorite Kemono content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/kemono-downloader"
                },
                {
                    "name": "Fancentro Downloader",
                    "description": "Fancentro Downloader is a tool that allows you to download videos from Fancentro for offline viewing. This software enables you to save your favorite Fancentro content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/fancentro-downloader"
                },
                {
                    "name": "BestJavPorn Downloader",
                    "description": "BestJavPorn Downloader is a tool that allows you to download videos from BestJavPorn for offline viewing. This software enables you to save your favorite BestJavPorn content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/bestjavporn-downloader"
                },
                {
                    "name": "Swag Downloader",
                    "description": "Swag Downloader is a tool that allows you to download videos from Swag for offline viewing. This software enables you to save your favorite Swag content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/swag-downloader"
                },
                {
                    "name": "Tokyomotion Downloader",
                    "description": "Tokyomotion Downloader is a tool that allows you to download videos from Tokyomotion for offline viewing. This software enables you to save your favorite Tokyomotion content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/tokyomotion-downloader"
                },
                {
                    "name": "Saucesenpai Downloader",
                    "description": "Saucesenpai Downloader is a tool that allows you to download videos from Saucesenpai for offline viewing. This software enables you to save your favorite Saucesenpai content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/saucesenpai-downloader"
                },
                {
                    "name": "Thisvid Downloader",
                    "description": "Thisvid Downloader is a tool that allows you to download videos from Thisvid for offline viewing. This software enables you to save your favorite Thisvid content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/thisvid-downloader"
                },
                {
                    "name": "Biguz Downloader",
                    "description": "Biguz Downloader is a tool that allows you to download videos from Biguz for offline viewing. This software enables you to save your favorite Biguz content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/biguz-downloader"
                },
                {
                    "name": "Doodporn Downloader",
                    "description": "Doodporn Downloader is a tool that allows you to download videos from Doodporn for offline viewing. This software enables you to save your favorite Doodporn content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/doodporn-downloader"
                },
                {
                    "name": "Analdin Downloader",
                    "description": "Analdin Downloader is a tool that allows you to download videos from Analdin for offline viewing. This software enables you to save your favorite Analdin content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/analdin-downloader"
                },
                {
                    "name": "Fakings Downloader",
                    "description": "Fakings Downloader is a tool that allows you to download videos from Fakings for offline viewing. This software enables you to save your favorite Fakings content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/fakings-downloader"
                },
                {
                    "name": "HeavyR Downloader",
                    "description": "HeavyR Downloader is a tool that allows you to download videos from Heavy-R for offline viewing. This software enables you to save your favorite Heavy-R content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/heavyr-downloader"
                },
                {
                    "name": "Pornoxo Downloader",
                    "description": "Pornoxo Downloader is a tool that allows you to download videos from Pornoxo for offline viewing. This software enables you to save your favorite Pornoxo content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/pornoxo-downloader"
                },
                {
                    "name": "Porndoe Downloader",
                    "description": "Porndoe Downloader is a tool that allows you to download videos from Porndoe for offline viewing. This software enables you to save your favorite Porndoe content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/porndoe-downloader"
                },
                {
                    "name": "Fullporner Downloader",
                    "description": "Fullporner Downloader is a tool that allows you to download videos from Fullporner for offline viewing. This software enables you to save your favorite Fullporner content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/fullporner-downloader"
                },
                {
                    "name": "Jiloviral Downloader",
                    "description": "Jiloviral Downloader is a tool that allows you to download videos from Jiloviral for offline viewing. This software enables you to save your favorite Jiloviral content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/jiloviral-downloader"
                },
                {
                    "name": "Jizzbunker Downloader",
                    "description": "Jizzbunker Downloader is a tool that allows you to download videos from Jizzbunker for offline viewing. This software enables you to save your favorite Jizzbunker content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/jizzbunker-downloader"
                },
                {
                    "name": "Youjizz Downloader",
                    "description": "Youjizz Downloader is a tool that allows you to download videos from Youjizz for offline viewing. This software enables you to save your favorite Youjizz content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/youjizz-downloader"
                },
                {
                    "name": "Paradisehill Downloader",
                    "description": "Paradisehill Downloader is a tool that allows you to download videos from Paradisehill for offline viewing. This software enables you to save your favorite Paradisehill content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/paradisehill-downloader"
                }
            ]
        }
    }
}
</script>